module.exports = __webpack_public_path__ + "assets/img/icon4-menu.ce8b4156.svg";